import API from "../../api";

const redeemPromoCode = (user, code) => {
    return new API(user).postRequest('/redeemPromoCode', {code: code});
}

export default redeemPromoCode;